var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.role == 'Z')?[_c('z',{ref:"roleZ",on:{"nextBtn":_vm.nextBtn,"send":_vm.send}})]:[_c('t')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }